import * as yup from "yup";
import { TaskCustomFieldDto } from "./TaskCustomFieldDto";
import {
  ExpectedTaskCustomDropdownFieldValue,
  TaskCustomFieldModel,
} from "./TaskCustomFieldModel";

const expectedTaskCustomDropdownFieldValueSchema = yup.object({
  id: yup.string().required(),
  value: yup.string().required(),
  order: yup.number().required(),
  color: yup.string(),
});

// TaskCustomFieldDto -> TaskCustomFieldModel
export const transformTaskCustomFieldDtoToTaskCustomFieldModel = (
  customFieldDto: TaskCustomFieldDto
): TaskCustomFieldModel => {
  const hasDropdownType = customFieldDto.field_type === "dropdown";

  return {
    id: customFieldDto.id,
    name: customFieldDto.field,
    type: customFieldDto.field_type,
    order: customFieldDto.order,
    createdBy: customFieldDto.created_by,
    isShownInCard: !!customFieldDto.show_in_card,
    values: hasDropdownType
      ? (customFieldDto.values || []).filter(
          (value): value is ExpectedTaskCustomDropdownFieldValue =>
            expectedTaskCustomDropdownFieldValueSchema.isValidSync(value)
        )
      : null,
  };
};

// TaskCustomFieldModel -> TaskCustomFieldDto
export const transformTaskCustomFieldModelToTaskCustomFieldDto = (
  customFieldModel: TaskCustomFieldModel,
  index?: number
): TaskCustomFieldDto => ({
  id: customFieldModel.id,
  field: customFieldModel.name,
  field_type: customFieldModel.type,
  show_in_card: customFieldModel.isShownInCard,
  order: typeof index !== "undefined" ? index + 1 : customFieldModel.order,
  created_by: customFieldModel.createdBy,
  values: customFieldModel.values,
});
